const VIDEO_PATH_RE =
  /\.(mp4|webm|mov|m4v|mkv|ogv)(?:[#?]|$)/i

export function isProbablyVideoUrl(url: string): boolean {
  const t = typeof url === "string" ? url.trim() : ""
  if (!t) return false
  const raw = (t.split(/[#?]/)[0] ?? t).split("/").pop() ?? ""
  return VIDEO_PATH_RE.test(raw) || /\.(mp4|webm|mov)$/i.test(raw)
}
